import { render, staticRenderFns } from "./purchaseSetting.vue?vue&type=template&id=0f4846e8"
import script from "./purchaseSetting.vue?vue&type=script&lang=js"
export * from "./purchaseSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports